import script from "./companies-index.vue?vue&type=script&setup=true&lang=js"
export * from "./companies-index.vue?vue&type=script&setup=true&lang=js"

import "./companies-index.vue?vue&type=style&index=0&id=031f4475&lang=css"

const __exports__ = script;

export default __exports__